import React from "react";
import { Row } from "react-bootstrap";
const SingleDetailHeader = ({ header, description }) => {
  return (
    <>
      <Row>
        <h4 className="fw-normal" style={{ fontFamily: "'Inter', sans-serif" }}>{header}</h4>
        <p className="text-muted" style={{ fontFamily: "'Inter', sans-serif" }}>{description}</p>
        <hr />
      </Row>
    </>
  );
};

export default SingleDetailHeader;
